/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ScreenshotsPublicRpc
 */
import * as References from './ScreenshotsPublicRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ScreenshotsPublicRpc#getForProfile
 */
export const GET_FOR_PROFILE_QUERY_FIELD_NAME = 'com_hubspot_marketplace_profiles_rpc_ScreenshotsPublicRpc_getForProfile';
export const GET_FOR_PROFILE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_FOR_PROFILE_QUERY_FIELD_NAME,
  args: ['profileId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getForProfileRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});